import React, { useEffect, useState } from 'react';
import { createLabSavedView, deleteLabSavedView, getLabSavedViews } from '../api/smartiLabApi';
import LabCard from '../components/LabCard';
import LabTable from '../components/LabTable';

const initialForm = { name: '', route: '/smarti-lab', filters: {} };

export default function SavedViewsPage() {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState(initialForm);

  const load = () => getLabSavedViews().then(setRows);
  useEffect(() => { load(); }, []);

  const handleCreate = async (event) => {
    event.preventDefault();
    await createLabSavedView(form);
    setForm(initialForm);
    load();
  };

  return (
    <div className="lab-page">
      <LabCard title="Viste salvate" description="Salva percorsi e preset di filtro di Smarti Lab senza cambiare le dashboard esistenti.">
        <form className="lab-form-grid" onSubmit={handleCreate}>
          <input className="lab-input" placeholder="Nome vista" value={form.name} onChange={(event) => setForm((current) => ({ ...current, name: event.target.value }))} />
          <input className="lab-input" placeholder="Percorso" value={form.route} onChange={(event) => setForm((current) => ({ ...current, route: event.target.value }))} />
          <button type="submit" className="lab-button">Salva vista</button>
        </form>
        <LabTable rows={rows} emptyTitle="Nessuna vista salvata." emptyDescription="Salva una combinazione di percorso e filtri per riaprire più velocemente il tuo flusso di analisi." columns={[
          { key: 'name', label: 'Nome' },
          { key: 'route', label: 'Percorso' },
          { key: 'updated_at', label: 'Aggiornata' },
          { key: 'id', label: 'Azioni', render: (value) => <button type="button" className="lab-inline-button danger" onClick={() => deleteLabSavedView(value).then(load)}>Elimina</button> },
        ]} />
      </LabCard>
    </div>
  );
}
